// src/components/leiaute/Content.js
// components/leiaute/Content.js
import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FaShoppingCart, FaBox, FaUsers, FaDollarSign, FaBirthdayCake, FaExclamationTriangle, FaFileInvoiceDollar, FaCalendarAlt } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { buscarDashboard } from '../../services/administrativo/dashService';
import { useConfigModulo } from '../../contexts/administrativo/ConfigModuloContext.js';
import { Line, Pie } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, ArcElement } from 'chart.js';
import './Content.css';
import { formatCurrency } from '../../utils/numberUtils';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, ArcElement);

function Content() {
  const today = new Date();
  const { configModuloSel } = useConfigModulo();
  const usaFinanceiro = configModuloSel?.usaFinanceiro === true;
  
  // Ajusta o primeiro dia do mês no ano anterior mais um mês
  const firstDayOfPrevYearPlusOneMonth = new Date(today.getFullYear() - 1, today.getMonth() + 1, 1);

  const formatDate = (date) => date.toISOString().split('T')[0]; // Formata a data no formato yyyy-MM-dd

  // Definir startDate como o primeiro dia do mês do ano anterior mais 1 mês
  const [startDate, setStartDate] = useState(formatDate(firstDayOfPrevYearPlusOneMonth));
  
  // Definir endDate como a data atual
  const [endDate, setEndDate] = useState(formatDate(today));

  const [dashData, setDashData] = useState({
    qtdeVenda: 0,
    totalVenda: 0,
    produtosCad: 0,
    clientesCad: 0,
  });
  const [curvaABC, setCurvaABC] = useState([]);
  const [aniversariantesMes, setAniversariantesMes] = useState([]);
  const [dashFinanceiro, setDashFinanceiro] = useState(null);
  const [financeiroLoading, setFinanceiroLoading] = useState(false);
  const [financeiroErro, setFinanceiroErro] = useState(false);
  const [chartData, setChartData] = useState({
    labels: [],
    datasets: [],
  });
  const [paymentChartData, setPaymentChartData] = useState({
    labels: [],
    datasets: [],
  });

  const [pieChartDataTopClients, setPieChartDataTopClients] = useState({
    labels: [],
    datasets: [],
  });

  const [pieChartDataTopGroups, setPieChartDataTopGroups] = useState({
    labels: [],
    datasets: [],
  });

  const [pieChartDataTopProducts, setPieChartDataTopProducts] = useState({
    labels: [],
    datasets: [],
  });

  const [pieChartDataTopBrands, setPieChartDataTopBrands] = useState({
    labels: [],
    datasets: [],
  });

  

  useEffect(() => {
    const fetchDashData = async () => {
      if (usaFinanceiro) {
        setFinanceiroLoading(true);
        setFinanceiroErro(false);
      } else {
        setDashFinanceiro(null);
      }

      try {
        const params = {
          DataIni: startDate,
          DataFim: endDate+' 23:59:59',
        };
        if (usaFinanceiro && Number(configModuloSel?.filialId) > 0) {
          params.FilialId = Number(configModuloSel.filialId);
        }
        const data = await buscarDashboard(params);
        setDashData(data.dashCards);
        setCurvaABC(data.dashCurvaABC);
        setAniversariantesMes(data.dashAniversariantesMes || []);
        setDashFinanceiro(usaFinanceiro ? data.dashFinanceiro || null : null);

      // Processar os dados para o gráfico de linha Vendas por Mês
      const labels = data.dashVendasByMes.map(item => item.labelMes);
      const valores = data.dashVendasByMes.map(item => item.valorVenda);

      setChartData({
        labels,
        datasets: [
          {
            label: 'Valor Vendido no Mês',
            data: valores,
            borderColor: '#007bff',
            backgroundColor: 'rgba(0, 123, 255, 0.2)',
            tension: 0.4,
          },
        ],
      });

      // Processar os dados para o gráfico de vendas por cliente
      setPieChartDataTopClients({
        labels: data.dashVendasByCliente.map((item) => item.nomeCliente),
        datasets: [
          {
            data: data.dashVendasByCliente.map((item) => item.vNota),
            backgroundColor: [
              '#007bff',
              '#28a745',
              '#ffc107',
              '#dc3545',
              '#6c757d',
              '#17a2b8',
              '#fd7e14',
            ],
          },
        ],
      });

      // Processar os dados para o gráfico de pizza (Vendas por Forma de Pagamento)
      const paymentLabels = data.dashVendasByFormaPag.map(item => item.formaPag);
      const paymentValues = data.dashVendasByFormaPag.map(item => item.valorPag);

      setPaymentChartData({
        labels: paymentLabels,
        datasets: [
          {
            data: paymentValues,
            backgroundColor: ['#007bff', '#28a745', '#ffc107', '#dc3545', '#6c757d'],
          },
        ],
      });      

      // Gráfico de vendas por grupos
      const groupLabels = data.dashVendasByGrupo.map((item) => item.descricao);
      const groupValues = data.dashVendasByGrupo.map((item) => item.valorVenda);

      setPieChartDataTopGroups({
        labels: groupLabels,
        datasets: [
          {
            data: groupValues,
            backgroundColor: [
              '#007bff',
              '#28a745',
              '#ffc107',
              '#dc3545',
              '#6c757d',
            ],
          },
        ],
      });

      // Gráfico de vendas por produtos
      const productLabels = data.dashVendasByProduto.map((item) => item.descricao);
      const productValues = data.dashVendasByProduto.map((item) => item.valorVenda);

      setPieChartDataTopProducts({
        labels: productLabels,
        datasets: [
          {
            data: productValues,
            backgroundColor: [
              '#007bff',
              '#28a745',
              '#ffc107',
              '#dc3545',
              '#6c757d',
            ],
          },
        ],
      });

      // Processar os dados para o gráfico Top 5 Marcas
      const brandLabels = data.dashVendasByMarca.map(item => item.descricao);
      const brandValues = data.dashVendasByMarca.map(item => item.valorVenda);

      setPieChartDataTopBrands({
        labels: brandLabels,
        datasets: [
          {
            data: brandValues,
            backgroundColor: [
              '#007bff',
              '#28a745',
              '#ffc107',
              '#dc3545',
              '#6c757d',
            ],
          },
        ],
      });      

      } catch (error) {
        console.error('Erro ao carregar os dados do dashboard:', error);
        if (usaFinanceiro) {
          setFinanceiroErro(true);
          setDashFinanceiro(null);
        }
      } finally {
        setFinanceiroLoading(false);
      }
    };

    fetchDashData();
  }, [startDate, endDate, usaFinanceiro, configModuloSel?.filialId]);

  const formatBirthday = (dataNascimento) => {
    if (!dataNascimento) {
      return '';
    }

    const date = new Date(dataNascimento);

    if (Number.isNaN(date.getTime())) {
      return '';
    }

    return date.toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
    });
  };

  const isBirthdayToday = (dataNascimento) => {
    if (!dataNascimento) {
      return false;
    }

    const date = new Date(dataNascimento);

    if (Number.isNaN(date.getTime())) {
      return false;
    }

    return date.getDate() === today.getDate() && date.getMonth() === today.getMonth();
  };

  const formatDisplayDate = (dateValue) => {
    if (!dateValue) {
      return '-';
    }

    const datePart = String(dateValue).split('T')[0];
    const [year, month, day] = datePart.split('-');
    return year && month && day ? `${day}/${month}/${year}` : '-';
  };


  return (
    <div className="p-4 dashboard-scroll">
      <div
        className="d-flex justify-content-between align-items-center mb-3"
        style={{ marginTop: '-20px' }}
      >
        <h2>Dashboard</h2>

        {/* Filtro por Data */}
        <div className="d-flex">
          <div className="me-2" style={{ maxWidth: '130px' }}>
            <label htmlFor="startDate" className="form-label">Data Inicial:</label>
            <input
              type="date"
              id="startDate"
              className="form-control"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            />
          </div>
          <div style={{ maxWidth: '130px' }}>
            <label htmlFor="endDate" className="form-label">Data Final:</label>
            <input
              type="date"
              id="endDate"
              className="form-control"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
            />
          </div>
        </div>
      </div>

      <div className="row g-3">
        {/* Card Vendas */}
        <div className="col-md-3">
          <div className="card text-center shadow-sm" style={{ backgroundColor: '#f8f9fa', border: 'none' }}>
            <div className="card-body">
              <FaShoppingCart size={40} color="#007bff" className="mb-3" />
              <h5 className="card-title text-primary">Vendas no Mês</h5>
              <p className="card-text fs-2 fw-bold text-dark">{dashData.qtdeVenda}</p>
            </div>
          </div>
        </div>

        {/* Card Valor Total de Vendas */}
        <div className="col-md-3">
          <div className="card text-center shadow-sm" style={{ backgroundColor: '#e2f0d9', border: 'none' }}>
            <div className="card-body">
              <FaDollarSign size={40} color="#28a745" className="mb-3" />
              <h5 className="card-title text-success">Valor Vendido no Mês</h5>
              <p className="card-text fs-2 fw-bold text-dark">{formatCurrency(dashData.totalVenda)}</p>
            </div>
          </div>
        </div>

        {/* Card Produtos Cadastrados */}
        <div className="col-md-3">
          <div className="card text-center shadow-sm" style={{ backgroundColor: '#fff3cd', border: 'none' }}>
            <div className="card-body">
              <FaBox size={40} color="#ffc107" className="mb-3" />
              <h5 className="card-title text-warning">Produtos Cadastrados</h5>
              <p className="card-text fs-2 fw-bold text-dark">{dashData.produtosCad}</p>
            </div>
          </div>
        </div>

        {/* Card Clientes Cadastrados */}
        <div className="col-md-3">
          <div className="card text-center shadow-sm" style={{ backgroundColor: '#d4edda', border: 'none' }}>
            <div className="card-body">
              <FaUsers size={40} color="#28a745" className="mb-3" />
              <h5 className="card-title text-success">Clientes Cadastrados</h5>
              <p className="card-text fs-2 fw-bold text-dark">{dashData.clientesCad}</p>
            </div>
          </div>
        </div>
      </div>

      {usaFinanceiro && (
        <section className="financeiro-dashboard mt-4" aria-labelledby="financeiro-dashboard-titulo">
          <div className="financeiro-cabecalho">
            <div>
              <h4 id="financeiro-dashboard-titulo" className="mb-1">Visão financeira</h4>
              <span className="text-muted">
                Posição em {formatDisplayDate(dashFinanceiro?.dataReferencia)}
              </span>
            </div>
            <Link to="/recebimento" className="btn btn-outline-primary btn-sm">
              Abrir Contas a Receber
            </Link>
          </div>

          {financeiroLoading && (
            <div className="financeiro-estado" role="status">
              Carregando posição financeira...
            </div>
          )}

          {!financeiroLoading && financeiroErro && (
            <div className="alert alert-warning mb-0" role="alert">
              Não foi possível carregar a posição financeira. Tente novamente em alguns instantes.
            </div>
          )}

          {!financeiroLoading && !financeiroErro && !dashFinanceiro && (
            <div className="alert alert-light border mb-0" role="status">
              A posição financeira não está disponível para a filial configurada.
            </div>
          )}

          {!financeiroLoading && !financeiroErro && dashFinanceiro && (
            <>
              <div className="row g-3 mt-1">
                <div className="col-xl-3 col-md-6">
                  <div className="financeiro-indicador financeiro-indicador-vencido">
                    <FaDollarSign className="financeiro-indicador-icone" />
                    <span>Saldo vencido</span>
                    <strong>{formatCurrency(dashFinanceiro.valorEmAtraso)}</strong>
                    <small>{dashFinanceiro.parcelasEmAtraso} parcela(s) vencida(s)</small>
                  </div>
                </div>
                <div className="col-xl-3 col-md-6">
                  <div className="financeiro-indicador financeiro-indicador-clientes">
                    <FaUsers className="financeiro-indicador-icone" />
                    <span>Clientes em atraso</span>
                    <strong>{dashFinanceiro.clientesEmAtraso}</strong>
                    <small>Cliente(s) com cobrança pendente</small>
                  </div>
                </div>
                <div className="col-xl-3 col-md-6">
                  <div className="financeiro-indicador financeiro-indicador-parcelas">
                    <FaFileInvoiceDollar className="financeiro-indicador-icone" />
                    <span>Parcelas vencidas</span>
                    <strong>{dashFinanceiro.parcelasEmAtraso}</strong>
                    <small>Necessitam acompanhamento</small>
                  </div>
                </div>
                <div className="col-xl-3 col-md-6">
                  <div className="financeiro-indicador financeiro-indicador-proximos">
                    <FaCalendarAlt className="financeiro-indicador-icone" />
                    <span>A vencer em 7 dias</span>
                    <strong>{formatCurrency(dashFinanceiro.valorAVencerSeteDias)}</strong>
                    <small>{dashFinanceiro.parcelasAVencerSeteDias} parcela(s), incluindo hoje</small>
                  </div>
                </div>
              </div>

              <div className="card shadow-sm financeiro-clientes-card mt-3">
                <div className="card-body">
                  <div className="d-flex align-items-center gap-2 mb-3">
                    <FaExclamationTriangle color="#dc3545" />
                    <h5 className="card-title mb-0">Clientes em atraso</h5>
                  </div>

                  {dashFinanceiro.clientes?.length > 0 ? (
                    <div className="table-responsive financeiro-clientes-table">
                      <table className="table table-hover align-middle mb-0">
                        <thead>
                          <tr>
                            <th>Cliente</th>
                            <th className="text-center">Parcelas</th>
                            <th>Vencimento mais antigo</th>
                            <th className="text-center">Atraso</th>
                            <th className="text-end">Saldo vencido</th>
                          </tr>
                        </thead>
                        <tbody>
                          {dashFinanceiro.clientes.map((cliente) => (
                            <tr key={`${cliente.clienteId ?? 'sem-cliente'}-${cliente.nomeCliente}`}>
                              <td className="fw-semibold">{cliente.nomeCliente || 'Cliente não informado'}</td>
                              <td className="text-center">{cliente.parcelasEmAtraso}</td>
                              <td>{formatDisplayDate(cliente.vencimentoMaisAntigo)}</td>
                              <td className="text-center">
                                <span className={`financeiro-atraso-badge ${cliente.diasAtraso >= 30 ? 'financeiro-atraso-critico' : ''}`}>
                                  {cliente.diasAtraso} dia(s)
                                </span>
                              </td>
                              <td className="text-end fw-bold text-danger">
                                {formatCurrency(cliente.valorEmAtraso)}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <div className="financeiro-sem-atrasos" role="status">
                      Nenhum cliente em atraso. A posição financeira está em dia.
                    </div>
                  )}
                </div>
              </div>
            </>
          )}
        </section>
      )}

      {aniversariantesMes.length > 0 && (
        <div className="row mt-4">
          <div className="col-md-12">
            <div className="card shadow-sm aniversariantes-card">
              <div className="card-body">
                <div className="d-flex align-items-center mb-3">
                  <FaBirthdayCake size={28} color="#dc3545" className="me-2" />
                  <h5 className="card-title mb-0">Aniversariantes do mês</h5>
                </div>

                <div className="aniversariantes-list">
                  {aniversariantesMes.map((aniversariante) => (
                    <div
                      className={`aniversariante-item ${isBirthdayToday(aniversariante.dataNascimento) ? 'aniversariante-hoje' : ''}`}
                      key={`${aniversariante.clienteId}-${aniversariante.dataNascimento}`}
                    >
                      <span className="aniversariante-data">
                        {formatBirthday(aniversariante.dataNascimento)}
                      </span>
                      <span className="aniversariante-nome">
                        {aniversariante.nomeCliente}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Gráficos */}
      <div className="row mt-5">
        <div className="col-md-6">
          <div className="card shadow-sm">
            <div className="card-body">
              <h5 className="card-title">Vendas por Mês</h5>
              <Line data={chartData} />
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="card shadow-sm">
            <div className="card-body">
              <h5 className="card-title">Vendas por Forma de Pagamento</h5>
              <Pie data={paymentChartData} />
            </div>
          </div>
        </div>  
        <div className="col-md-3">
          <div className="card shadow-sm">
            <div className="card-body">
              <h5 className="card-title">Top 5 Clientes</h5>
              <Pie data={pieChartDataTopClients} />
            </div>
          </div>
        </div>      
      </div>

      <div className="row mt-5">                
        <div className="col-md-3">
          <div className="card shadow-sm">
            <div className="card-body">
              <h5 className="card-title">Venda por Top 5 Grupos</h5>
              <Pie data={pieChartDataTopGroups} />
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="card shadow-sm">
            <div className="card-body">
              <h5 className="card-title">Top 5 Produtos Mais Vendidos</h5>
              <Pie data={pieChartDataTopProducts} />
            </div>
          </div>
        </div>
        
        <div className="col-md-3">
          <div className="card shadow-sm">
            <div className="card-body">
              <h5 className="card-title">Top 5 Marcas</h5>
              <Pie data={pieChartDataTopBrands} />
            </div>
          </div>
        </div>
        
      </div>

      


      {/* Curva ABC dos Produtos */}
      <div className="row mt-5">
        <div className="col-md-12">
          <div className="card shadow-sm">
            <div className="card-body">
              <h5 className="card-title">Curva ABC dos Produtos</h5>
              <div className="table-responsive curva-abc-table">
                <table className="table table-bordered table-hover">
                  <thead className="table-light">
                    <tr>
                      <th>#</th>
                      <th style={{ textAlign: 'center' }}>Id</th>
                      <th>Produto</th>
                      <th style={{ textAlign: 'center' }}>Preço Un.</th>
                      <th style={{ textAlign: 'center' }}>Qtde. Vendida</th>
                      <th style={{ textAlign: 'center' }}>Valor Vendido</th>
                      <th style={{ textAlign: 'center' }}>Faturamento (%)</th>
                      <th style={{ textAlign: 'center' }}>Classificação</th>
                    </tr>
                  </thead>
                  <tbody>
                    {curvaABC.length > 0 ? (
                      curvaABC.map((item, index) => (
                        <tr key={item.produtoId}>
                          <td className={`classification-${item.classificacao.toLowerCase()}`} style={{ textAlign: 'right' }}>
                            {index + 1}
                          </td>
                          <td className={`classification-${item.classificacao.toLowerCase()}`} style={{ textAlign: 'right' }}>
                            {item.produtoId}
                          </td>
                          <td className={`classification-${item.classificacao.toLowerCase()}`}>
                            {item.descricao}
                          </td>
                          <td className={`classification-${item.classificacao.toLowerCase()}`} style={{ textAlign: 'right' }}>
                            {formatCurrency(item.precoUn)}
                          </td>
                          <td className={`classification-${item.classificacao.toLowerCase()}`} style={{ textAlign: 'right' }}>
                            {item.qtdeVendida}
                          </td>
                          <td className={`classification-${item.classificacao.toLowerCase()}`} style={{ textAlign: 'right' }}>
                            {formatCurrency(item.valorVendido)}
                          </td>
                          <td className={`classification-${item.classificacao.toLowerCase()}`} style={{ textAlign: 'right' }}>
                            {item.percentual.toFixed(2)}%
                          </td>
                          <td className={`classification-${item.classificacao.toLowerCase()}`} style={{ textAlign: 'center' }}>
                            {item.classificacao}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="8" className="text-center">
                          Nenhum dado disponível.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Content;
